import { React } from "react";

import { Navigate } from "react-router-dom";
import { useState } from "react";
 
import Sigecap from "../../assets/logo_sigecap.png";
import Governo from "../../assets/paraiba_texto_branco.png";
import Sefaz from "../../assets/sefaz.png";

import { LayoutComponents } from "../../components/LayoutComponents";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

export const Login = () => {
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const { signIn, signed } = useContext(AuthContext);

  const UserEPasswordOK = () => toast.success("Logando.....");
  const UserEpassword = () => toast.error("preencha todos os campos");
  const User = () =>
    toast.warning("Campo usuário está vázio, coloque o seu usuário do windows");
  const Password = () => toast.info("O campo senha está vázio");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      username,
      password,
    };

    if (!username && !password) {
      UserEpassword();
      return;
    }

    if (username !== username) {
      setTimeout(() => {
        UserEPasswordOK();
      }, 1000);
      return;
    }

    if (!username) {
      User();
      return;
    }
      
    if (!password) {
      Password();
      return;
    }

    await signIn(data);  

    /*  */
  };
  /*   console.log(signed);
   */ if (!signed) {
    return (
      <LayoutComponents>
        <form onSubmit={handleSubmit} className="login-form">
          <span className="login-form-title" style={{ marginTop: "-50px" }}>
            <img src={Sigecap} alt="Sigecap" />
          </span>

          <br />
          <br />
          <div className="wrap-input">
            <input
              className={username !== "" ? "has-val input" : "input"}
              type="username"
              value={username}
              onChange={(e) => setUserName(e.target.value)}
            />
            <span
              className="focus-input"
              data-placeholder="Usuário do windows"
            ></span>
          </div>

          <div className="wrap-input">
            <input
              className={password !== "" ? "has-val input" : "input"}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span className="focus-input" data-placeholder="Senha"></span>
          </div>

          <div className="container-login-form-btn">
            <button type="submit" className="login-form-btn">
              Entrar
            </button>
          </div>
          <ToastContainer />
          <br />
          <br />
          <div className="login-form-title">
           <a href="https://paraiba.pb.gov.br/" target="_blank">
              <img
                src={Governo}
                style={{ width: "45%" }}
                alt="Governo da Paraiba"
              />
            </a>

           <a href="https://www.sefaz.pb.gov.br/" target="_blank"> 
            <img
                src={Sefaz}
                style={{ width: "40%", marginLeft: "8px" }}
                alt="Sefaz"
              />
            </a>
          </div>
        </form>
      </LayoutComponents>
    );
  } else {
    return <Navigate to="/esat/sigecap/painel" />;
  }
};
